module.exports = __webpack_public_path__ + "img/South-Sudan.993b9908.png";